export const INTERNAL_TRAFFIC_COOKIE = '_1n73rn4l'
export const INTERNAL_TRAFFIC_VALUE = '1'
export const INTERNAL_IP_ADDRESS = '127.0.0.1'
